import {type Writable, writable} from "svelte/store";
import type {StorageDocument} from "$lib/types/documents";

export const storageDocuments: Writable<StorageDocument[]> = writable([])